import { PRESETS } from '../brandKits';
import { portalForHostname } from './portalExperience';

/** Apply install/browser identity before React; page titles remain owned by routes. */
export function applyPortalDocumentMetadata(hostname) {
    const portal = portalForHostname(hostname);
    if (!portal || typeof document === 'undefined') return;
    const kit = PRESETS[portal.kitId];
    document.documentElement.setAttribute('data-portal', portal.experience);
    for (const [selector, attributes] of [
        ['link[rel="icon"]', { rel: 'icon', href: kit.logos.favicon }],
        ['link[rel="apple-touch-icon"]', { rel: 'apple-touch-icon', href: kit.logos.favicon }],
        ['link[rel="manifest"]', { rel: 'manifest', href: '/portal-shells/tyson/manifest.json' }],
        ['meta[name="theme-color"]', { name: 'theme-color', content: kit.colors.primary }],
    ]) {
        let elements = [...document.head.querySelectorAll(selector)];
        if (!elements.length) {
            const element = document.createElement(selector.startsWith('meta') ? 'meta' : 'link');
            document.head.appendChild(element);
            elements = [element];
        }
        elements.forEach(element => Object.entries(attributes).forEach(([name, value]) => element.setAttribute(name, value)));
    }
}
